import {RestResource} from '../rest'
import {KPI_SERVER} from '../server'
import {athubAxios} from '../../util'

const kpiResult = new RestResource({server: KPI_SERVER, resource: 'kpiresult'});

kpiResult.exportExcel = (params) => {
    let url = `${KPI_SERVER}/kpiresult/excel`;
    return new Promise((resolve, reject) => {
        athubAxios.post(url, params, {
            responseType: 'blob',
            headers: {
                orgId: localStorage.getItem("authorg"),
                sites: localStorage.getItem("authsites"),
            }
        }).then(responseBody => {
            if (responseBody.status == 200) {
                resolve(responseBody.data);
            }
        }).catch(error => {
            reject(error);
        });
    });
}

export default kpiResult;